export const GET_TOP_DELEGATORS_START = 'INFO/GET_TOP_DELEGATORS_START';
export const GET_TOP_DELEGATORS_SUCCESS = 'INFO/GET_TOP_DELEGATORS_SUCCESS';
export const GET_TOP_DELEGATORS_ERROR = 'INFO/GET_TOP_DELEGATORS_ERROR';
export const UPDATE_TOP_DELEGATORS = 'INFO/UPDATE_TOP_DELEGATORS';
